import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';


function SiteMap(props) {
    const location = useLocation();

    const create_view = function () {
        var paths = location.pathname.split('/');
        var pathname = props.pathname ?? paths[paths.length - 1].toLowerCase();
        if (location.pathname.toLowerCase().indexOf('/search') >= 0) {
            pathname = "search";
        }

        var data = [];
        var systemname = '資源循環網';
        switch (pathname) {
            case 'sitemap'.toLowerCase():
                data.push(<span className="arrowBread">
                    <span><Link title="首頁" to="/">首頁</Link></span>
                    <span> &gt; </span>
                    <span>網站導覽</span>
                </span>);
                document.title = '網站導覽' + '-' + systemname;
                break;
            case 'about'.toLowerCase():
                data.push(<span className="arrowBread">
                    <span><Link title="首頁" to="/">首頁</Link></span>
                    <span> &gt; </span>
                    <span>關於網站</span>
                    <span> &gt; </span>
                    <span>認識循環經濟</span>
                </span>);
                document.title = '認識循環經濟' + '-' + systemname;
                break;
            case 'meetlist'.toLowerCase():
            case 'meetings'.toLowerCase():
            case 'meetdetail'.toLowerCase():
                data.push(<span className="arrowBread">
                    <span><Link title="首頁" to="/">首頁</Link></span>
                    <span> &gt; </span>
                    <span>會議專區</span>
                </span>);
                document.title = '會議專區' + '-' + systemname;
                break;
            case "resourceRecyclingPromotion".toLowerCase():
                data.push(<span className="arrowBread">
                    <span><Link title="首頁" to="/">首頁</Link></span>
                    <span> &gt; </span>
                    <span>資源循環推動</span>
                    <span> &gt; </span>
                    <span>資源循環推動說明</span>
                </span>);
                document.title = '資源循環推動說明' + '-' + systemname;
                break;
            case "recycleReport3".toLowerCase():
                data.push(<span className="arrowBread">
                    <span><Link title="首頁" to="/">首頁</Link></span>
                    <span> &gt; </span>
                    <span>資源循環推動</span>
                    <span> &gt; </span>
                    <span>歷年推動計畫</span>
                </span>);
                document.title = '歷年推動計畫' + '-' + systemname;
                break;
            case "recycleReport".toLowerCase():
                data.push(<span className="arrowBread">
                    <span><Link title="首頁" to="/">首頁</Link></span>
                    <span> &gt; </span>
                    <span>資源循環推動</span>
                    <span> &gt; </span>
                    <span>資源回收再利用年報</span>
                </span>);
                document.title = '資源回收再利用年報' + '-' + systemname;
                break;
            case "recycleReport2".toLowerCase():
                data.push(<span className="arrowBread">
                    <span><Link title="首頁" to="/">首頁</Link></span>
                    <span> &gt; </span>
                    <span>資源循環教材</span>
                    <span> &gt; </span>
                    <span>資源循環教材</span>
                </span>);
                document.title = '資源循環教材' + '-' + systemname;
                break;
            case "recycleReport4".toLowerCase():
                data.push(<span className="arrowBread">
                    <span><Link title="首頁" to="/">首頁</Link></span>
                    <span> &gt; </span>
                    <span>資源循環教材</span>
                    <span> &gt; </span>
                    <span>相關資源</span>
                </span>);
                document.title = '相關資源' + '-' + systemname;
                break;
            case "recycleReport5".toLowerCase():
                data.push(<span className="arrowBread">
                    <span><Link title="首頁" to="/">首頁</Link></span>
                    <span> &gt; </span>
                    <span>資源循環教材</span>
                    <span> &gt; </span>
                    <span>圖卡懶人包</span>
                </span>);
                document.title = '圖卡懶人包' + '-' + systemname;
                break;

            case "recycleReport6".toLowerCase():
                data.push(<span className="arrowBread">
                    <span><Link title="首頁" to="/">首頁</Link></span>
                    <span> &gt; </span>
                    <span>資源循環教材</span>
                    <span> &gt; </span>
                    <span>影片</span>
                </span>);
                document.title = '影片' + '-' + systemname;
                break;

            case "recycleReport7".toLowerCase():
                data.push(<span className="arrowBread">
                    <span><Link title="首頁" to="/">首頁</Link></span>
                    <span> &gt; </span>
                    <span>資源循環教材</span>
                    <span> &gt; </span>
                    <span>分享成果</span>
                </span>);
                document.title = '分享成果' + '-' + systemname;
                break;

            case "news".toLowerCase():
                data.push(<span className="arrowBread">
                    <span><Link title="首頁" to="/">首頁</Link></span>
                    <span> &gt; </span>
                    <span>訊息中心</span>
                    <span> &gt; </span>
                    <span>循環經濟新聞</span>
                </span>);
                document.title = '循環經濟新聞' + '-' + systemname;
                break;

            case "seminar".toLowerCase():
                data.push(<span className="arrowBread">
                    <span><Link title="首頁" to="/">首頁</Link></span>
                    <span> &gt; </span>
                    <span>訊息中心</span>
                    <span> &gt; </span>
                    <span>研討會</span>
                </span>);
                document.title = '研討會' + '-' + systemname;
                break;
            case "search".toLowerCase():
                data.push(<span className="arrowBread">
                    <span><Link title="首頁" to="/">首頁</Link></span>
                    <span> &gt; </span>
                    <span>網站搜尋</span>
                </span>);
                document.title = '網站搜尋' + '-' + systemname;
                break;
        }

        data.push(<br />);
        return (data);
    }


    return (create_view());
}

export default SiteMap;